import { on, $, $all, listen, getDataAttr } from "@olmokit/dom";
import BaseDialog from "@olmokit/core/dialog";
import Collapsable from "@olmokit/core/collapsable";
import "./Base.scss";


export function DialogBase() {

  console.log('DialogBase mounted');

  const $root = $('.FormDownload:');
  const $feedback = $(".of:feedback", $root);

  const $success = $(".of:feedback__success", $feedback);
  const $failure = $(".of:feedback__failure", $feedback);

  const areaForm = Collapsable($(".FormDownload:form"));
  const areaFeedback = Collapsable($feedback);  

  let dialog;
  listen("click", `[data-dialog]`, (event) => {
    event.preventDefault();
    console.log(event);
    const dialogId = getDataAttr(event.target, "dialog");
    dialog = BaseDialog($(`#${dialogId}`), {
      id: dialogId,
    });
    dialog.open();
    areaForm.expand();
    areaFeedback.collapse();    
  });

  const close = $all(".DialogBase:close");
  for (let i = 0; i < close.length; i++) {
    on(close[i], "click", function () {
      dialog.close();
    });
  }

}
